<template>
  <div v-loading="loading"  element-loading-text="数据加载中..." style="height: 100%;width: 100%">
    <el-container  style="height: 100%;width: 100%">
      <el-aside style="height: 100%;overflow-y: hidden;width: 200px">
        <div class="center">
          <el-row>
            <el-col :span="24">
              <el-select style="width: 100%;" @change="checkSaveStatus()" v-model="thing" filterable clearable placeholder="物件名称">
                <el-option v-for="item in things" :key="item.id" :label="item.label" :value="item.value" ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-button v-if="thing" class="button center" style="background-color: #0478e4;height: 50px">{{thingName}}</el-button>
            </el-col>
          </el-row>
        </div>

        <div class="scrollbar" style="overflow-y: auto;height:90%;">
          <draggable v-if="thing" :class="batchNoBool == false?'thingSelect initHeight':'thingSelect'"
                     :list="batchNos" ghost-class="ghost" chosen-class="chosenClass"
                     animation="300"  @add="onSort" :sort="true" :group="group">
            <template #item="{ element }">
              <div v-if="JSON.stringify(element) !== '{}' && element.assembly_residue_num > 0" :style="element.is_material_shortage == false?'border-left: #67c23a 3px solid !important;':'border-left: red 3px solid !important;'"  class="item button1 cursor">
                <span>{{ element.wujian_name }}-</span>
                <span>{{ element.scheduling_floor }}</span>
                <div :class="element.is_material_shortage == false?'batchNoStyle1':'batchNoStyle1_1'" style="border-top: #909399 1px solid;border-bottom: #909399 1px solid;">
                  <span>{{element.batch_no}}</span>
                  <span style="color: #67c23a;margin-left: 45px;">{{element.reality_num}}</span>
                  <span style="color: black">&nbsp;/&nbsp;</span>
                  <span style="color: #ff00f3;">{{element.assembly_residue_num}}</span>
                  <span style="color: black;">&nbsp;/&nbsp;{{element.total_reality_num}}&nbsp;/&nbsp;</span>
                  <span style="color: #909399">{{element.unit_num}}</span>
                </div>
              </div>
            </template>
          </draggable>
        </div>
      </el-aside>
      <div style="padding: 0;width:90%;height: 100%;margin-left: 2px;overflow-x: hidden;overflow-y: hidden">
        <el-row style="height: 37px;overflow-y: auto;margin-left: 5px;" class="border center">
            <el-col :span="24" style="text-align: center;margin-top: 2px">
              <el-input size="small" v-model="batchNo" style="width: 80px;margin-left: -10px" @keyup.enter="selectProductionAll" @change="selectProductionAll" placeholder="批号查询"></el-input>
              <el-button size="small" style="width: 55px;margin-left: 5px" type="primary" :loading="batchQueryLoading" @click="selectProductionAll">{{ $t('makeSchedule.paintingProductionScheduling.batchQuery') }}</el-button>
              <el-button size="small" class="week" @click="clickThisWeek">{{ $t('makeSchedule.paintingProductionScheduling.thisWeek') }}</el-button>
              <el-button size="small" class="week" style="margin-left: -10px" @click="clickLastWeek"><el-icon><ElIconArrowLeft /></el-icon>{{ $t('makeSchedule.paintingProductionScheduling.lastWeek') }}</el-button>
              <el-date-picker size="small" v-model="week" format="M月-D日" value-format="MM-DD" type="daterange" disabled range-separator="~" style="width: 160px;"/>
              <el-button size="small" class="week" @click="clickNextWeek">{{ $t('makeSchedule.paintingProductionScheduling.afterWeek') }}<el-icon><ElIconArrowRight /></el-icon></el-button>
              <el-button size="small" style="width: 55px;margin-left: -1px" type="primary" :loading="oneProductionSchedulingLoading" @click="oneClickProductionScheduling">{{ $t('makeSchedule.AssemblyProductionScheduling.oneClickProductionScheduling') }}</el-button>
              <el-button size="small" style="width: 55px;margin-left: 5px" type="danger" :loading="oneCleanLoading" @click="oneClickClean">{{ $t('makeSchedule.AssemblyProductionScheduling.oneClickClean') }}</el-button>
              <el-button size="small" style="width: 55px;margin-left: 5px" type="warning" :loading="oneMoveBackLoading" @click="oneClickMoveBack">{{ $t('makeSchedule.AssemblyProductionScheduling.oneClickMove') }}</el-button>
              <el-button size="small" style="width: 55px;margin-left: 5px" type="primary" :loading="saveAllDateLoading" @click="saveAllDate">保存</el-button>
              <span style="background-color: rgb(103, 194, 58);margin-left: 10px">&nbsp;&nbsp;</span> <span>:正常</span>
              <span style="margin-left: 10px;background-color: red">&nbsp;&nbsp;</span> <span>:缺料</span>
              <span style="margin-left: 10px;color: #67c23a;">{{ $t('makeSchedule.AssemblyProductionScheduling.todayProduction') }}</span>/
              <span style="color: #f56c6c;">{{ $t('makeSchedule.AssemblyProductionScheduling.todayProductionScheduling') }}</span>/
              <span style="color: black;">{{ $t('makeSchedule.AssemblyProductionScheduling.yesterday') }}</span>/
              <span style="color: #909399;">{{ $t('makeSchedule.AssemblyProductionScheduling.batchNo') }}</span>
            </el-col>
        </el-row>

        <div ref="total_height" style="display: flex;height: 95%;width: 100%;overflow-x: auto;">
          <div class="total_style" v-for="item in state.dataList" :key="item">
            <div class="border color time" style="height: 46px;" :style="item.expireTimeClass">
              <div>{{ item.time }}</div>
              <div>{{ item.week }}</div>
            </div>
            <div v-if="!item.line_bool" :class="!item.line_bool?'prompt data_style1':''" :style="maxHeight">产线未开</div>
            <div v-if="item.line_bool" class="data_style">
              <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2" :style="lineCnt.expireTimeClass">
                <div class="data_style3">
                  <span v-if="lineCnt.dayShiftCnt" class="data_style4">&nbsp;白{{lineCnt.dayShiftCnt }}&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt" class="data_style4_1">&nbsp;夜{{ lineCnt.nightShiftCnt }}&nbsp;</span>
                </div>
                <div>
                  <draggable :style="lineCnt.height" :class="lineCnt.class_line_name" :list="lineCnt.lineData"
                             ghost-class="ghost" filter=".forbid" chosen-class="chosenClass" animation="300"
                             @add="onSort" :sort="true" :group="item.expireTimeClass?item:'group'">
                    <template #item="{ element }">
                      <div :class="item.expireTimeClass?'forbid':''">
                        <div v-if="JSON.stringify(element) !== '{}'"
                             :class="element.is_material_shortage == false?'item2':'item2_1'"
                             :style="element.status?'background-color: #c6c8ce':''">
                          <el-row style="line-height: initial;">
                            <el-col :span="24">
                              <span>{{ element.wujian_name }}-</span>
                              <span>{{ element.scheduling_floor }}</span>
<!--                              <span style="font-size: 12px;color: #94D82D">{{ element.letter }}</span>-->
                            </el-col>
                            <div style="margin-top: -18px;margin-left: 92%;">
                                <span @click="materialDetailsClick(element,item.time,lineCnt)" class="cursor"
                                      style="font-size: 15px;"><el-icon><ElIconMoreFilled/></el-icon></span>
                            </div>
                          </el-row>
                          <div :class="element.is_material_shortage == false?'batchNoStyle1':'batchNoStyle1_1'"
                               style="border-top: #909399 1px solid;border-bottom: #909399 1px solid;">
                            <span>{{ element.batch_no }}</span>
                            <span style="color: #67c23a;margin-left: 35px;">{{ element.reality_num }}</span>
                            <span style="color: black">&nbsp;/&nbsp;</span>
                            <span style="color: #f56c6c">{{ element.plan_production_quantity}}&nbsp;</span>
                            <span style="color: black;">/&nbsp;{{element.total_reality_num}}&nbsp;/&nbsp;</span>
                            <span style="color: #909399">{{element.unit_num}}</span>
                          </div>
                          <el-tooltip class="custom-tooltip" :content="element.remark" placement="top">
                            <div v-if="element.remark" class="overflow-text" style="height: 100%;">备注：{{ element.remark }}</div>
                          </el-tooltip>
                        </div>
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
  <el-dialog title="计划详情" :close-on-click-modal="false"  :before-close="beforeClose1"  v-model="materialDetailsBool" >
    <el-form :model="formWujianData" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物件番号：">
            <el-input v-model="formWujianData.wujian_id" disabled placeholder="物件番号" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物件名称：">
            <el-input v-model="formWujianData.wujian_name" disabled placeholder="物件名称" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="楼层信息：">
            <el-input v-model="formWujianData.scheduling_floor"  disabled placeholder="楼层信息" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="批号：">
            <el-input v-model="formWujianData.batch_no" disabled placeholder="批号" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="出荷日期：">
            <el-date-picker v-model="formWujianData.outbound_date" disabled type="date" placeholder="出荷日期" style="width: 90%"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排产日期：">
            <el-date-picker v-model="formWujianData.production_scheduling_date" disabled type="date" placeholder="排产日期" style="width: 90%"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="排产产线：">
            <div v-if="!lineBool" class="border" style="width: 25px;height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">{{formWujianData.lineCnt}}</div> <!--  白班-->
            <div v-if="lineBool" class="border" style="width: 25px;height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">{{formWujianData.lineCnt}}</div> <!--  夜班-->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实际数量：">
            <el-input-number disabled v-model="formWujianData.reality_num" placeholder="实际数量"  style="width: 90%;"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="单线日产量：">
            <el-input-number min="1" disabled v-model="formWujianData.line_production" placeholder="单线日产量" style="width: 90%;"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="本计划数：">
            <el-input-number min="1"  v-model="formWujianData.plan_production_quantity" :disabled="this.formWujianData.planStatus == true?true:false" placeholder="本计划数" style="width: 90%"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="备注：">
            <el-input v-model="formWujianData.remark" rows="5" type="textarea" placeholder="备注" style="width: 95%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div style="width: 100%;display: flex;flex-direction: column;align-items: center">
        <el-button type="primary" style="width: 100px;" @click="saveWujianOneBatchData()">保存</el-button>
      </div>
    </el-form>
  </el-dialog>

  <el-dialog width="30%" title="提示" :close-on-click-modal="false"  :before-close="beforeClose2" v-model="confirmBool" draggable>
    <span style="font-size: 20px">您确认将该批号进行拆分吗？</span>
    <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 40px;">
      <el-button type="primary"  style="width: 100px;" @click="cancelEvent()">取消拆分</el-button>
      <el-button type="primary"  style="width: 100px;" @click="confirmEvent()">确认拆分</el-button>
    </div>
  </el-dialog>

  <el-dialog width="30%" title="提示" :show-close="false" :close-on-click-modal=false  v-model="confirmBool1" draggable>
    <span style="font-size: 20px">超出该产线的日产量，您是否继续排产？</span>
    <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 40px;">
      <el-button type="danger"  style="width: 100px;" @click="cancelEvent1()">否</el-button>
      <el-button v-if="!params.shiftLineDataBool" type="success"  style="width: 100px;" @click="confirm1_1()">优先排产</el-button>
      <el-button v-if="!params.shiftLineDataBool" type="primary"  style="width: 100px;" @click="confirm1_2()">次后排产</el-button>
      <el-button v-if="params.shiftLineDataBool" type="primary"  style="width: 100px;" @click="confirm1_3()">是</el-button>
    </div>
  </el-dialog>

  <el-dialog title="物件信息" width="60%" :close-on-click-modal=false :show-close=false v-model="formDataBool" draggable>
    <div v-if="params.to_lineData.length > 1" style="font-size: 20px;text-align: center;"><b>本物件同{{params.currentLineData.letter}}类型、计划数量信息</b></div>
    <el-row style="margin-top: 10px">
      <el-col :span="12">
        <span style="font-size: 18px;font-weight: bold;">总排产计划数：<span style="color: #94D82D">{{params.currentLineData.line_production}}</span></span>
      </el-col>
      <el-col :span="24">
        <span style="font-size: 18px;">以下是已排产的批号：</span>
      </el-col>
    </el-row>
    <div v-for="item in formData1.lineData" :key="item.id">
      <el-row v-if="item.plan_production_quantity" >
        <el-col :span="6">
          <span style="font-size: 18px">物件：{{item.wujian_id}}</span>
        </el-col>
        <el-col :span="6">
          <span style="font-size: 18px">批号：{{item.batch_no}}</span>
        </el-col>
        <el-col :span="6">
          <span style="font-size: 18px">楼层：{{item.floor}}</span>
        </el-col>
        <el-col :span="6">
          <span style="font-size: 18px">计划数：{{item.plan_production_quantity}}</span>
        </el-col>
      </el-row>
    </div>
    <el-row style="margin-top: 10px">
      <el-col :span="24">
        <span style="font-size: 18px;font-weight: bold;">剩余待排产计划数：<span style="color: #94D82D">{{formData1.residueCnt}}</span></span>
      </el-col>
      <el-col :span="24">
        <span style="font-size: 18px;">以下是选中的批号：</span>
      </el-col>
    </el-row>
    <el-row v-if="params.currentLineData.plan_production_quantity?params.currentLineData.plan_production_quantity:params.currentLineData.assembly_residue_num">
      <el-col :span="6">
        <span style="font-size: 18px">物件：{{ params.currentLineData.wujian_id }}</span>
      </el-col>
      <el-col :span="6">
        <span style="font-size: 18px">批号：{{ params.currentLineData.batch_no }}</span>
      </el-col>
      <el-col :span="6">
        <span style="font-size: 18px">楼层：{{ params.currentLineData.floor }}</span>
      </el-col>
      <el-col :span="6">
        <span style="font-size: 18px">计划数：{{ params.currentLineData.plan_production_quantity?params.currentLineData.plan_production_quantity:params.currentLineData.assembly_residue_num }}</span>
      </el-col>
    </el-row>
    <div style="font-size: 20px;text-align: center;margin-top: 50px"><b>其他物件信息</b></div>
    <div v-for="item in formData" :key="item.id">
      <el-row>
        <el-col :span="5">
          <span style="font-size: 18px">排产人：{{item.full_name}}</span>
        </el-col>
        <el-col :span="5">
          <span style="font-size: 18px">物件：{{item.wujian_id}}</span>
        </el-col>
        <el-col :span="5">
          <span style="font-size: 18px">批号：{{item.batch_no}}</span>
        </el-col>
        <el-col :span="5">
          <span style="font-size: 18px">楼层：{{item.floor}}</span>
        </el-col>
        <el-col :span="4">
          <span style="font-size: 18px">计划数：{{item.plan_production_quantity}}</span>
        </el-col>
      </el-row>
    </div>
    <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 40px;">
      <el-button type="primary"  style="width: 100px;" @click="cancelEvent2()">取消排产</el-button>
      <el-button v-if="params.continueProduction" type="primary"  style="width: 100px;" @click="confirmEvent2()">继续排产</el-button>
      <el-button v-if="!params.continueProduction" type="success"  style="width: 100px;" @click="confirm1_1()">优先排产</el-button>
      <el-button v-if="!params.continueProduction" type="primary"  style="width: 100px;" @click="confirm1_2()">次后排产</el-button>
      <el-button v-if="!params.continueProduction1" type="primary"  style="width: 100px;" @click="confirmEvent()">确认拆分</el-button>
    </div>
  </el-dialog>
  <el-dialog width="30%" title="提示" :show-close="false" :close-on-click-modal=false  v-model="confirmBool2" draggable>
    <span style="font-size: 20px">【{{wujianId?wujianId:thing}}物件】进行了排产，您是否保存？</span>
    <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 40px;">
      <el-button type="primary"  style="width: 100px;" @click="cancelEvent3()">取消</el-button>
      <el-button type="primary"  style="width: 100px;" @click="confirmEvent3()">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import draggable from "vuedraggable";
import moment from "moment";
import {ElMessage, ElMessageBox} from "element-plus";
export default {
  name: "AssemblyProductionScheduling",
  components: {draggable},
  data() {
    return {
      confirmBool: false,
      confirmBool1: false,
      confirmBool2: false,
      startDate: '', //用来处理前段显示时间的
      endDate: '', //用来处理前段显示时间的
      startTime: '', //传后端的时间
      endTime: '', //传后端的时间
      assemblyEndTime:'',
      group: {
        name:'group',
        pull:true,
        put:true  //允许拖入
      },
      things:[],
      thing:'',
      wujianId:'',
      thingName:'',
      batchNos: [],
      state:{
        dataList:[],
      },
      week: [], //时间组件数据
      weekList: [], //一个星期的时间
      params:{
        startTime: '',  //开始时间
        endTime: '',    //结束时间
        from_className:'',//拖拽结束前的div class名称
        to_className:'', //拖拽结束后的div class名称
        to_lineData:{},
        from_lineData:{},
        currentLineData:{},
        confirmBool: false,
      },
      materialDetailsBool: false, //控制物料详情页面
      formWujianData: {},
      plan_production_quantity:'',
      remark: '',
      batchQueryLoading:false,
      saveAllDateLoading:false,
      oneProductionSchedulingLoading: false,//一键排产
      oneCleanLoading: false,//一键清除
      oneMoveBackLoading: false,//一键平移
      lineBool:false,//false表示白班 true表示夜班
      loading:false,
      batchNoBool:false,
      maxHeight:"",//获取页面的最大高度
      formData: [],
      formData1: {},
      formDataBool: false,
      containsLine: false,
      lineDataAll: [],
      batchNo:'',
    }
  }, methods: {
    async getBatchNos() {
      if (!this.thing) {
        return
      }
      this.loading = true;
      await this.$axios.post('mfg/assemblyProduction/getBatchNos', this.thing).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.batchNos = res.data;
        this.batchNoBool = false;
        for (let item of this.things) {
          if (item.value == this.thing) {
            this.thingName = item.label;
          }
        }

        for (let item of this.batchNos) {
          if (item.assembly_residue_num != 0) {
            this.batchNoBool = true;
          }
        }
        //console.log("batchNos=", this.batchNos)
        this.getCalendarLineData(this.thing, this.startTime, this.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    deleteAssemblySaveStatus(){
      this.loading = true;
      let params = {thing:this.thing, wujianId:this.wujianId, startTime:this.startTime, endTime:this.endTime}
      this.$axios.post('mfg/assemblyProduction/deleteAssemblySaveStatus', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.batchNos = res.data;
        this.batchNoBool = false;
        for (let item of this.things) {
          if (item.value == this.thing) {
            this.thingName = item.label;
          }
        }

        for (let item of this.batchNos) {
          if (item.assembly_residue_num != 0) {
            this.batchNoBool = true;
          }
        }

        //console.log("batchNos=", this.batchNos)
        this.getCalendarLineData(this.thing, this.startTime, this.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    checkSaveStatus() {
      let params = {thing:this.thing,startTime:this.startTime, endTime:this.endTime}
      if(localStorage.getItem("assemblyWujianId") != null && localStorage.getItem("assemblyWujianId") != 'undefined') {
        this.wujianId = JSON.parse(localStorage.getItem("assemblyWujianId"))
      }
      //console.log("wujianId=",this.wujianId)
      if (this.wujianId) {
        params.thing = this.wujianId;
      }
      //console.log("wujianId2=",params.thing)
      if (!params.thing) {
        return
      }
      this.$axios.post('mfg/assemblyProduction/checkSaveStatus', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        //console.log("checkSaveStatus==",res.data)
        if (res.data) {
          this.confirmBool2 = true;
        } else {
          localStorage.setItem("assemblyWujianId",JSON.stringify(this.thing))
          this.getBatchNos();
        }
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getWuJianInFo() {
      this.$axios.post('mfg/wujianPlan/getWujianName').then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("获取数据失败");
        }

        this.things = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    beforeClose1() {
      this.materialDetailsBool = false;
      //判断有没有改动数据
      if (this.plan_production_quantity !== this.formWujianData.plan_production_quantity
          || this.remark !== this.formWujianData.remark) {
        //改动就刷新
        this.getBatchNos();
      }
    },
    beforeClose2() {
      this.confirmBool = false;
      this.getBatchNos();
    },
    confirmEvent() {
      this.formDataBool = false;
      this.confirmBool = false;
      this.params.confirmBool = true;
      this.updateCalendarLineData()
    },
    cancelEvent() {
      this.confirmBool = false
      this.params.confirmBool = false;
      this.updateCalendarLineData()
    },
    async confirm1_1() {
      this.formDataBool = false
      this.confirmBool1 = false;
      this.params.confirmBool = null;
      this.params.priorityScheduling  = true; //优先排产状态
      this.params.secondaryScheduling  = false;
      await this.updateCalendarLineData()
    },
    async confirm1_2() {
      this.formDataBool = false
      this.confirmBool1 = false;
      this.params.confirmBool = null;
      this.params.secondaryScheduling  = true; //次要排产状态
      this.params.priorityScheduling  = false;
      await this.updateCalendarLineData()
    },
    async confirm1_3() {
      this.confirmBool1 = false;
      this.params.confirmBool = null;
      await this.updateCalendarLineData()
    },
    cancelEvent1() {
      this.confirmBool1 = false
      this.getBatchNos();
    },
    confirmEvent2() {
      this.formDataBool = false
      this.params.confirmBool = false;
      this.updateCalendarLineData();
    },
    cancelEvent2() {
      this.formDataBool = false;
      this.getBatchNos();
    },
    confirmEvent3() {
      this.confirmBool2 = false;
      this.saveAllDate1();
    },
    cancelEvent3() {
      this.confirmBool2 = false;
      this.deleteAssemblySaveStatus();
    },
    async wujianDate() {
      let lineData = [];
      let lineData1 = [];
      let lineData2 = [];
      //这个物件类型待排剩余数
      let cnt = 0
      for (let obj of this.params.to_lineData) {
        if (this.params.currentLineData.letter == obj.letter && this.params.currentLineData.line_production == obj.line_production) {
          lineData.push(obj)
        }
      }

      for (let obj of lineData) {
        if (obj.plan_production_quantity != undefined && obj.plan_production_quantity != null
            && obj.plan_production_quantity != this.params.currentLineData.plan_production_quantity) {
          lineData1.push(obj)
        }

        //处理 相互拖拽  一样的批号数据
        if (obj.plan_production_quantity != undefined && obj.plan_production_quantity != null
            && obj.plan_production_quantity == this.params.currentLineData.plan_production_quantity
            && obj.batch_no == this.params.currentLineData.batch_no) {
            lineData2.push(obj)
        }
      }

      //一样的批号数据 随便哪个都可以
      if (lineData2.length == 2) {
        lineData1.push(lineData2[0])
      }

      this.formData1.lineData = lineData1;
      for (let obj of lineData1) {
        cnt += parseInt(obj.plan_production_quantity);
      }

      let cnt1 = parseInt(this.params.currentLineData.line_production) - cnt;
      this.formData1.residueCnt = cnt1 > 0? cnt1: 0;
    },
    async onSort(e) {
      this.loading = true;
      //当插入、移除、改变位置时会触发该事件
      this.params.from_className =  e.from.className;
      this.params.to_className =  e.to.className;
      this.params.currentLineData = e.item._underlying_vm_;
      //console.log("currentLineData===",e)
      for (let obj1 of this.state.dataList) {
        for (let obj2 of obj1.line_cnt) {
          if (this.params.to_className == obj2.class_line_name) {
            this.params.to_lineData = obj2.lineData;
          }

          if (this.params.from_className == obj2.class_line_name) {
            this.params.from_lineData = obj2.lineData;
          }
        }
      }

      this.params.startTime = this.startTime;
      this.params.endTime = this.endTime;
      //计算日产量
      await this.getLineProduction();
      if (this.params.currentLineData.line_production == null || this.params.currentLineData.line_production == 'undefined') {
        return this.getBatchNos();
      }
      //console.log("params===",this.params)
      //拖回该物件批号数据源
      if (this.params.to_className.toString().includes('thingSelect')) {
        //添加取消排产成功提示
        this.params.prompt = true;
        this.containsLine = true;
        await this.updateCalendarLineData();
        //各个产线上线批号的数据相互拖拽
      } else if (this.params.to_className.toString().includes("shift_line_data") && this.params.from_className.toString().includes("shift_line_data")) {
        this.params.shiftLineDataBool = true;//判断是否是相互拖拽   （相互拖拽如果超出日产量，选择是不需要拆分数据以及移动数据）
        //获取本物件信息
        await this.wujianDate();
        //池子前的计划数量
        let cnt = 0;
        for (let job of this.params.to_lineData) {
          if (job.area > 0) {
            if (job.line_production == this.params.currentLineData.line_production && this.params.currentLineData.letter == job.letter) {
              cnt += job.plan_production_quantity;
            }
          }
        }

        await this.checkCalendarLineData1(this.params, cnt);
      } else {
        //特殊情况，直接拖到池子，该拖动的批号plan_production_quantity值是不存在的，所以要加上currentLineData.assembly_residue_num
        this.params.shiftLineDataBool = false;
        //获取本物件信息
        await this.wujianDate();
        //池子前的计划数量
        let cnt = 0;
        for (let job of this.params.to_lineData) {
          if (job.area > 0) {
            if (job.line_production == this.params.currentLineData.line_production && this.params.currentLineData.letter == job.letter) {
              if (job.plan_production_quantity) {
                cnt += job.plan_production_quantity;
              }
            }
          }
        }

        //加上拖动数据
        if (this.params.currentLineData.area > 0) {
          cnt += this.params.currentLineData.assembly_residue_num;
        }
        ////console.log("cnt==",cnt)
        await this.checkCalendarLineData(this.params, cnt);
      }
    },
    async checkCalendarLineData(params, cnt) {
      await this.$axios.post('mfg/assemblyProduction/checkCalendarLineData', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false;
          this.getBatchNos();
          return this.$message.error(res.message);
        }
        //console.log("checkCalendarLineData=", cnt)
        this.containsLine = res.data.containsLine;
        let lineProduction = params.currentLineData.line_production;
        this.checkDate(this.containsLine, params, lineProduction, cnt, res);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async checkCalendarLineData1(params, cnt) {
      await this.$axios.post('mfg/assemblyProduction/checkCalendarLineData', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false;
          this.getBatchNos();
          return this.$message.error(res.message);
        }
        //console.log("checkCalendarLineData=", res)
        this.containsLine = res.data.containsLine;
        let lineProduction = params.currentLineData.line_production;
        this.checkDate1(this.containsLine, params, lineProduction, cnt, res);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //拖动检验数据方法
    checkDate(containsLine, params, lineProduction, cnt, res) {
      //按默认产线排产
      if (containsLine) {
        this.formData = res.data.data
        //其他产线也排了并且有数据
        if (this.formData.length > 0) {
          //大于日产量
          if (cnt - lineProduction > 0) {
            let count = 0; //(params.to_lineData包含了自己，所以要大于1)
            for (let job of params.to_lineData) {
              if (job.area > 0) {
                if (job.line_production == lineProduction && params.currentLineData.letter == job.letter) {
                  count += 1;
                }
              }
            }

            //有相同的日产量
            if (count > 1) {
              this.params.continueProduction = false; //(优先，次要)
              this.params.continueProduction1 = true;
            } else {
              this.params.continueProduction1 = false; //(拆分，不拆分)
              this.params.continueProduction = true;
            }

          } else {
            this.params.continueProduction = true;
            this.params.continueProduction1 = true;
          }
          this.formDataBool = true;
        } else {
          if (params.currentLineData.area > 0) {
            //大于日产量
            if (cnt - lineProduction > 0) {
              // if (params.to_lineData.length > 1) {
              //   this.confirmBool1 = true;
              // } else {
              //   this.confirmBool = true;
              // }
              let count = 0; //(params.to_lineData包含了自己，所以要大于1)
              for (let job of params.to_lineData) {
                if (job.area > 0) {
                  if (job.line_production == lineProduction  && params.currentLineData.letter == job.letter) {
                    count += 1;
                  }
                }
              }

              //有相同的日产量
              if (count > 1) {
                this.confirmBool1 = true;  //(优先，次要)
              } else {
                this.confirmBool = true; //(拆分，不拆分)
              }

              //小于日产量
            } else {
              this.params.confirmBool = false;
              this.updateCalendarLineData();
            }
          } else {
            this.params.confirmBool = false;
            this.updateCalendarLineData();
          }
        }
        //不默认产线排产
      } else {
        this.formData = res.data.data
        //其他产线也排了并且有数据
        if (this.formData.length > 0) {
          //大于日产量
          if (cnt - lineProduction > 0) {
            let count = 0; //(params.to_lineData包含了自己，所以要大于1)
            for (let job of params.to_lineData) {
              if (job.area > 0) {
                if (job.line_production == lineProduction  && params.currentLineData.letter == job.letter) {
                  count += 1;
                }
              }
            }

            //有相同的日产量
            if (count > 1) {
              this.params.continueProduction = false; //(优先，次要)
              this.params.continueProduction1 = true;
            } else {
              this.params.continueProduction1 = false; //(拆分，不拆分)
              this.params.continueProduction = true;
            }

          } else {
            this.params.continueProduction = true;
            this.params.continueProduction1 = true;
          }
          this.formDataBool = true;
        } else {
          if (params.currentLineData.area > 0) {
            //大于日产量
            if (cnt - lineProduction > 0) {
              if (params.to_lineData.length > 1) {
                // if (params.to_lineData.length > 1) {
                //   this.confirmBool1 = true;
                // } else {
                //   this.confirmBool = true;
                // }
                let count = 0; //(params.to_lineData包含了自己，所以要大于1)
                for (let job of params.to_lineData) {
                  if (job.area > 0) {
                    if (job.line_production == lineProduction  && params.currentLineData.letter == job.letter) {
                      count += 1;
                    }
                  }
                }

                //有相同的日产量
                if (count > 1) {
                  this.confirmBool1 = true;  //(优先，次要)
                } else {
                  this.confirmBool = true; //(拆分，不拆分)
                }

              } else {
                this.confirmBool = true;
              }
            } else {
              //小于日产量
              this.params.confirmBool = false;
              this.updateCalendarLineData();
            }
          } else {
            this.params.confirmBool = false;
            this.updateCalendarLineData();
          }
        }
      }
    },
    //各个产线上线批号的数据相互拖拽
    checkDate1(containsLine, params, lineProduction, cnt, res) {
      //按默认产线排产
      if (containsLine) {
        this.formData = res.data.data
        //其他产线也排了并且有数据
        if (this.formData.length > 0) {
          this.params.continueProduction = true;
          this.params.continueProduction1 = true;
          this.formDataBool = true;
        } else {
          if (params.currentLineData.area > 0) {
            //大于日产量
            if (cnt - lineProduction > 0) {
              if (params.to_lineData.length > 1) {
                return this.confirmBool1 = true;
              }
              this.params.confirmBool = false;
              this.updateCalendarLineData();
            } else {
              this.params.confirmBool = false;
              this.updateCalendarLineData();
            }
          } else {
            this.params.confirmBool = false;
            this.updateCalendarLineData();
          }

        }
        //不默认产线排产
      } else {
        this.formData = res.data.data
        //其他产线也排了并且有数据
        if (this.formData.length > 0) {
          this.params.continueProduction = true;
          this.params.continueProduction1 = true;
          this.formDataBool = true;
        } else {
          if (params.currentLineData.area > 0) {
            //大于日产量
            if (cnt - lineProduction > 0) {
              if (params.to_lineData.length > 1) {
                return this.confirmBool1 = true;
              }
              this.params.confirmBool = false;
              this.updateCalendarLineData();
            } else {
              this.params.confirmBool = false;
              this.updateCalendarLineData();
            }
          } else {
            this.params.confirmBool = false;
            this.updateCalendarLineData();
          }
        }
      }
    },
    async updateCalendarLineData() {
      //console.log("updateCalendarLineData==========",this.params)
      await this.$axios.post('mfg/assemblyProduction/updateCalendarLineData', this.params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false;
          this.getBatchNos();
          return this.$message.error(res.message);
        }

        this.getBatchNos();
        //该批号为FIN不需要提示 message信息
        if (!this.containsLine && parseInt(this.params.currentLineData.area) > 0) {
          this.$message.warning({
            message: "您未排到默认产线上，当前默认第一次设置产线日产量为："+this.params.currentLineData.line_production+"",
            duration: 5000 // 设置5秒后关闭
          });
        } else {
          if (this.params.prompt) {
            this.$message.success("取消排产成功");
          } else {
            this.$message.success("排产成功");
          }
        }
        this.params.prompt = false;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getCalendarLineData(thing,startTime,endTime) {
      let params = {thing:thing, startTime:startTime, endTime:endTime, weekList:this.weekList}
      console.log("getCalendarLineData====",params)
      this.$axios.post('mfg/assemblyProduction/getCalendarLineData', params).then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }
        this.state.dataList = res.data;
        //console.log("dataList==",this.state.dataList)
        this.maxHeight = '';
        setTimeout(() => {
          this.getMaxHeight();
        }, 200);
        this.loading = false;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //物件计划详情
    materialDetailsClick(element,time,lineCnt) {
      this.materialDetailsBool = true;
      this.formWujianData = element;
      let cnt;
      if (lineCnt.dayShiftCnt) {
        cnt = lineCnt.dayShiftCnt;
        this.lineBool = false;
      } else {
        cnt = lineCnt.nightShiftCnt;
        this.lineBool = true;
      }

      this.formWujianData.form_className = lineCnt.class_line_name;
      this.formWujianData.lineCnt = cnt;
      this.formWujianData.scheduling_floor = element.scheduling_floor;
      let timeString = time.toString().substring(0,time.toString().length - 1);
      let timeList = timeString.toString().split("月");
      let month = timeList[0];
      let day = timeList[1];
      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      let date;
      //特殊处理跨年的
      if (this.startTime.substring(0,4) !== this.endTime.substring(0,4)) {
        if (parseInt(month) < 12) { //这是下一年
          date = this.endTime.substring(0,4) + '-' + month + '-' + day;
        } else {
          date = this.startTime.substring(0,4) + '-' + month + '-' + day;
        }
      } else {
        date = this.startTime.substring(0,4) + '-' + month + '-' + day;
      }

      this.formWujianData.production_scheduling_date = date;
      const currentDate = moment().format('YYYY-MM-DD');
      if (moment(date).isBefore(moment(currentDate))) {
        this.formWujianData.planStatus = true;
      } else {
        this.formWujianData.planStatus = false;
      }

      this.plan_production_quantity = this.formWujianData.plan_production_quantity;
      this.remark = this.formWujianData.remark;
    },
    saveAllDate1() {
      this.saveAllDateLoading = true;
      let params = {startTime: this.startTime, endTime: this.endTime, wujian_id: this.wujianId}
      if (!this.wujianId) {
        params.wujian_id = this.thing;
      }
      this.$axios.post('mfg/assemblyProduction/saveAllDate', params).then(response => {
        this.saveAllDateLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.getBatchNos();
        return this.$message.success("保存成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    saveAllDate() {
      this.saveAllDateLoading = true;
      let params = {startTime: this.startTime, endTime: this.endTime, wujian_id: this.thing}
      this.$axios.post('mfg/assemblyProduction/saveAllDate', params).then(response => {
        this.saveAllDateLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.getBatchNos();
        return this.$message.success("保存成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    oneClickProductionScheduling() {
      this.oneProductionSchedulingLoading = true;
      let newBatchNos = [];
      for (let obj of this.batchNos) {
        if (obj.assembly_residue_num > 0) {
          if (obj.line_production_class_name != null && obj.line_production_class_name != 'undefined') {
            newBatchNos.push(obj);
          }
        }
      }

      this.loading = true;
      let params = {wujian_id: this.thing, batchNoList:newBatchNos, dataList: this.state.dataList}
      this.$axios.post('mfg/assemblyProduction/oneClickProductionScheduling', params).then(response => {
        this.oneProductionSchedulingLoading = false;
        let res = response.data
        if (res.code !== 0){
          this.loading = false;
          return this.$message.error(res.message);
        }

        this.getBatchNos();
        return this.$message.success("一键排产成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    oneClickClean() {
      ElMessageBox.confirm(
          '您需要清除两周未过期的排产数据吗？',
          '警告',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(() => {
        this.oneCleanLoading = true;
        this.loading = true;
        let params = {wujian_id: this.thing, endTime: this.endTime}
        this.$axios.post('mfg/assemblyProduction/oneClickClean', params).then(response => {
          this.oneCleanLoading = false;
          let res = response.data
          if (res.code !== 0) {
            this.loading = false;
            return this.$message.error(res.message);
          }

          this.getBatchNos();
          return this.$message.success("清除成功");
        }, error => {
          this.$message.error(`页面数据加载失败` + error.message);
        })
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: '取消成功',
        })
      })
    },
    oneClickMoveBack() {
      ElMessageBox.confirm(
          '您需要移动两周未过期的排产数据吗？（往后移动一天）',
          '警告',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(() => {
        this.oneMoveBackLoading = true;
        this.loading = true;
        let params = {wujian_id: this.thing, endTime: this.endTime}
        this.$axios.post('mfg/assemblyProduction/oneClickMoveBack', params).then(response => {
          this.oneMoveBackLoading = false;
          let res = response.data
          if (res.code !== 0) {
            this.loading = false;
            return this.$message.error(res.message);
          }

          this.getBatchNos();
          return this.$message.success("移动成功");
        }, error => {
          this.$message.error(`页面数据加载失败` + error.message);
        })
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: '取消成功',
        })
      })
    },
    saveWujianOneBatchData() {
      this.materialDetailsBool = false;
      this.loading = true;
      //console.log("saveWujianDataClick=",this.formWujianData)
      let params = {planProductionQuantity: this.plan_production_quantity, formWujianData: this.formWujianData}
      this.$axios.post('mfg/assemblyProduction/saveWujianOneBatchData', params).then(response => {
        let res = response.data
        if (res.code !== 0){
          this.getBatchNos();
          return this.$message.error(res.message);
        }

        this.getBatchNos();
        return this.$message.success("保存成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //根据批号查询排产详情
    selectProductionAll() {
      // if (!this.thing) {
      //   return this.$message.error("物件不能为空");
      // }
      if (!this.batchNo) {
        return;
      }
      this.batchQueryLoading = true;
      this.loading = true;
      let params = {batchNo: this.batchNo}
      this.$axios.post('mfg/assemblyProduction/selectProductionAll', params).then(response => {
        this.loading = false;
        this.batchQueryLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.state.dataList = res.data;
        return this.$message.success("查询成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //本周
    clickThisWeek() {
      if (!this.thing) {
        return this.$message.error("物件不能为空");
      }
      this.loading = true;
      let obj = this.getCurrWeekDays();
      this.formatTime(obj.startTime,obj.endTime);
      this.getBatchNos();
    },
    //上周
    clickLastWeek() {
      if (!this.thing) {
        return this.$message.error("物件不能为空");
      }
      this.loading = true;
      let obj = this.getLastWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime,obj.endTime);
      this.getBatchNos();
    },
    //下周
    clickNextWeek() {
      if (!this.thing) {
        return this.$message.error("物件不能为空");
      }
      this.loading = true;
      let obj = this.getBelowWeekDays(this.startTime, this.endTime);
      //console.log("clickNextWeek=",obj)
      this.formatTime(obj.startTime,obj.endTime);
      //console.log("clickNextWeek=",this.weekList)
      this.getBatchNos();
    },
    // 获取本周开始结束时间
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      let endDate = new Date(this.assemblyEndTime); // 结束日期
      obj.startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      obj.endTime = moment(endDate.valueOf()).format('YYYY-MM-DD');
      return obj
    },
    // 获取上一周的开始结束时间
    getLastWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(-7,'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(-7,'days').format('YYYY-MM-DD');
      return obj
    },
    // 获取下一周的开始结束时间
    getBelowWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(7,'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(7,'days').format('YYYY-MM-DD');
      return obj
    },
    //处理时间
    formatTime(startTime, endTime) {
      console.log("startTime=",startTime)
      console.log("endTime=",endTime)
      this.startTime = startTime;
      this.endTime = endTime;
      this.week = [];
      this.weekList = [];
      let startDate = moment(startTime).add(-1,'days');
      let endDate = moment(endTime);
      while (startDate.isBefore(endDate)) {
        startDate.add(1,'days');
        let date = moment(startDate).format('YYYY-MM-DD')
        let time = moment(date).format('MM') + "月" + moment(date).format('DD') + "日";
        this.weekList.push({time});
      }

      let weeks = ["一","二","三","四","五","六","日"]
      let cnt = 0;
      for (let i = 0; i < this.weekList.length; i++) {
        if (i === 7) {
          cnt = 0;
        }
        this.weekList[i]['week'] = "(" + weeks[cnt] + ")";
        cnt += 1;
      }

      this.startDate = moment(startTime).format('MM') + "-" + moment(startTime).format('DD');
      this.endDate = moment(endTime).format('MM') + "-" + moment(endTime).format('DD');
      this.week.push(this.startDate);
      this.week.push(this.endDate);
    },
    getAssemblyEndTime(){
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/assemblyProduction/getAssemblyEndTime',params).then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime,obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getMaxHeight() {
      let h_max = 0;
      var  widthBox = document.getElementsByClassName('data_style');
      for (let i = 0; i < widthBox.length; i++) {
        if (h_max < widthBox[i].clientHeight) {
          h_max = widthBox[i].clientHeight;
        }
      }

      let totalHeight = this.$refs.total_height.clientHeight - 60;
      if (h_max < totalHeight) {
        h_max = totalHeight;
      }

      this.maxHeight = "height: " + h_max + "px;";
    },
    destructionCheckSaveStatus() {
      let params = {thing:this.thing,startTime:this.startTime, endTime:this.endTime}
      this.wujianId = JSON.parse(localStorage.getItem("assemblyWujianId"))
      if (this.wujianId) {
        params.thing = this.wujianId;
      }

      if (!params.thing) {
        return
      }
      this.$axios.post('mfg/assemblyProduction/checkSaveStatus', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        //console.log("checkSaveStatus==",res.data)
        if (res.data) {
          let windowObj = {}
          windowObj.icon = "system/view";
          windowObj.component = "bus/make_schedule/AssemblyDialog";
          windowObj.name = '组立排产提示';
          windowObj.parentData = params;
          windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
          windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
          windowObj.no_min = true
          windowObj.max = true

          this.$store.dispatch('core/openWindow', windowObj)
        }
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async getLineProduction() {
      await this.$axios.post('mfg/assemblyProduction/getLineProduction', this.params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }

        this.params.currentLineData.line_production = res.data.line_production;
        this.params.currentLineData.letter = res.data.letter;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    }
  },created() {
    this.getAssemblyEndTime();
    this.getWuJianInFo();
  },beforeUnmount() {
    this.destructionCheckSaveStatus();
  },mounted() {

  }
}
</script>

<style scoped>
.border {
  border:rgb(216, 220, 230) 1px solid;
}

.color {
  background-color: #e7e7e7;
}

.center {
  text-align: center;
  line-height: 32px;
}

.cursor {
  cursor: pointer;
}

/*一下是拖拽样式*/
.item {
  border: solid 2px #0478e4 !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: whitesmoke;
}

.item:hover {
  background-color: whitesmoke;
}

.item2 {
  border: solid 2px #0478e4 !important;
  border-left: solid 3px rgb(103, 194, 58) !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color:  whitesmoke;
}

.item2_1 {
  border: solid 2px #0478e4 !important;
  border-left: solid 3px red !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color:  whitesmoke;
}

.item2:hover {
  background-color: whitesmoke;
}

.item2_1:hover {
  background-color: whitesmoke;
}

.chosenClass {
  font-size: 15px;
  font-weight: bold;
}

/*button样式*/
.button {
  color: white;
  border-radius: 5px 5px 0 0;
  width: 100%;
  margin-top: 5px;
}

/*div样式*/
.week {
  margin-left: 1px;
  border: #909399 0 solid;background-color: white; color: rgb(4, 134, 254);
}

.total_style {
  width:auto;
  align-items:center;
  margin-left: 5px;
}

.time {
  width:100%;
  text-align: center;
  margin-top: 5px;
}

.data_style {
  width:224px;
  height: auto;
}

.data_style1 {
  width:224px;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 5px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  margin-top: 5px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width:100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.data_style4 {
  background-color: #0478e4;
  font-size: 14px;
}

.data_style4_1 {
  background-color: black;
  margin-left: 2px;
  font-size: 14px;
}


.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}

/*动态样式*/
.batchNoStyle1_1 {
  color: red
}

.batchNoStyle1 {
  color: #0478e4
}

.scrollbar::-webkit-scrollbar{
  display: none;
}

.prompt {
  color:rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.initHeight {
  border: #d8dce6 2px solid;
  height: 50px;
}

.el-select .el-input {
  display: flex;
  height: 40px;
}

/*.info-title {*/
/*  width: 200px;*/
/*  overflow:hidden; !*溢出的部分隐藏*!*/
/*  white-space: nowrap; !*文本不换行*!*/
/*  text-overflow:ellipsis;!*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*!*/
/*}*/

.overflow-text {
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
  width: 100%; /* 设置容器的宽度 */
  position: relative; /* 为悬停时显示的提示框做准备 */
}

.custom-tooltip {
  width: 150px; /* 设置提示框的宽度 */
  max-height: 200px; /* 设置提示框的最大高度 */
  overflow-y: auto; /* 如果内容超出高度，显示滚动条 */
}

/*.overflow-text:hover {*/
/*  white-space: normal; !* 悬停时允许文本换行 *!*/
/*  overflow: visible; !* 悬停时显示全部内容 *!*/
/*  z-index: 1; !* 确保内容在其他元素之上 *!*/
/*}*/

</style>